enum ReminderFormField {
    CustomDate = 'customDate',
    DateTypeOption = 'dateTypeOption',
}

export default ReminderFormField;
